<template>
  <v-toolbar flat color="transparent" class="pt-2 toolbar">
    <v-layout wrap>
      <v-flex xs12>
       <v-select v-model="form.id" class="white--text"
         :label="isEmpty ? '申込がありません' : printLabel"
         :items="getItems"
         item-text="text"
         item-value="value"
         :disabled="isLoading"
         @change="select"
       />
      </v-flex>
    </v-layout>
  </v-toolbar>
</template>
<script>
export default {
  name: 'clientApplyToolbar',
  components: {
  },
  props: [
    'item'
  ],
  data () {
    return {
      config: {
        status: {
          loading: false
        }
      },
      form: {
        id: ''
      },
      store: {
        items: []
      }
    }
  },
  mounted () {
    this.get()
  },
  methods: {
    get: function () {
      this.$set(this.config.status, 'loading', true)
      this.axios.post(this.$url.api + 'user/apply/get/items', {
      }, {
        headers: {
          'user-token': this.$localStorage.get('jwt')
        }
      }).then(res => {
        console.log(res)
        this.$set(this.config.status, 'loading', false)
        if (res.data && res.data.success) {
          let items = res.data.data.reverse()
          this.$set(this.store, 'items', items)
          this.$set(this.form, 'id', items.length ? items[0].id : '')
          this.select()
        }
      })
    },
    select: function () {
      this.$nextTick(() => {
        let idx = this.store.items.findIndex(it => { return it.id === this.form.id })
        if (idx >= 0) {
          this.$emit('select', this.store.items[idx])
        } else {
          this.$emit('select', {})
        }
      })
    },
    insert: function (item) {
      let idx = this.store.items.findIndex(it => { return it.id === item.id })
      if (idx >= 0) {
        console.log(item)
        this.store.items.splice(idx, 1, Object.assign(this.store.items[idx], item))
      } else {
        this.store.items.push(item)
        this.$set(this.form, 'id', item.id)
      }
      this.$nextTick(() => {
        this.select()
      })
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isEmpty () {
      return this.store.items.length === 0
    },
    isSet () {
      return !!(this.$props.item && this.$props.item.id)
    },
    printLabel () {
      if (this.$props.item) {
        let item = this.$props.item
        return [
          (item.country && this.$meta.nations[item.country]) ? ('国：' + this.$meta.nations[item.country]) : '',
          item.city ? ('都市：' + item.city) : ''
        ].join(' ')
      } else {
        return '申込一覧'
      }
    },
    getItem () {
      return this.$props.item ? this.$props.item : {}
    },
    getItems () {
      return this.store.items.map(it => {
        return {
          text: (it.published_at && it.published_at !== '0000-00-00 00:00:00') ? `【確定】${it.title}` : (it.status === 4 ? `【確認中】${it.title}` : it.title),
          value: it.id
        }
      })
    }
  }
}
</script>

<style lang="scss">
</style>
